export var RoutesConst;
(function (RoutesConst) {
    RoutesConst["ROOT"] = "/";
    /** Профиль пользователя */
    RoutesConst["PROFILE"] = "profile";
    /** Площадки */
    RoutesConst["PLACES"] = "places";
    /** Расписания */
    RoutesConst["SCHEDULES"] = "schedule";
    /** Шаблоны рсписаний */
    RoutesConst["SCHEDULE_TEMPLATES"] = "templates";
    /** Календарные расписания */
    RoutesConst["CALENDAR"] = "calendar";
    /** Суточные расписания площадки */
    RoutesConst["TIME"] = "time";
    /** Игры */
    RoutesConst["GAMES"] = "games";
    /** Пользователи */
    RoutesConst["USERS"] = "users";
    /** Управление */
    RoutesConst["MANAGE"] = "manage";
    // /////////////////
    /** Виды спорта */
    RoutesConst["SPORTS"] = "sports";
    /** Города */
    RoutesConst["CITIES"] = "cities";
    // //////////
    RoutesConst["ADD"] = "add";
    RoutesConst["EDIT"] = "edit";
    // Тайм-фрейм для списков игр
    RoutesConst["ALL"] = "all";
    RoutesConst["PAST"] = "past";
    // Типы игр (общие, личные)
    RoutesConst["PERSONAL"] = "personal";
})(RoutesConst || (RoutesConst = {}));
